import {
  ButtonContainer,
  Title,
  TitleContainer,
  TopContainer,
  Description,
} from './ConfirmModal.styled';
import Button from 'components/Button/Button';
import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction } from 'react';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Modal } from '../Modal/Modal';
import { Level } from '../Modal/type';

interface IConfirmProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm?: () => void;
  onCancel?: () => void;
  description?: string;
  title: string;
  disabled?: boolean;
  level?: Level;
}

export const ConfirmModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
  onCancel,
  description,
  title,
  disabled = false,
  level = 'FIRST',
}: IConfirmProps) => {
  const { t } = useTranslation();
  const { isSmallPhone } = useBreakpointFlag();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      modalStyle={{
        position: 'fixed',
        margin: 'auto',
        width: isSmallPhone ? '90%' : '500rem',
        minWidth: isSmallPhone ? '90%' : 'auto',
      }}
      level={level}
    >
      <TopContainer>
        <TitleContainer>
          <Title>{title}</Title>
        </TitleContainer>
        <TitleContainer>
          <Description>{description}</Description>
        </TitleContainer>
      </TopContainer>
      <ButtonContainer>
        <Button
          disabled={disabled}
          onClick={() => {
            onCancel && onCancel();
          }}
          secondary
          width="200rem"
          label={t('Cancel')}
        />
        <Button
          disabled={disabled}
          primary
          width="200rem"
          label={t('Confirm')}
          onClick={() => {
            onConfirm && onConfirm();
          }}
        />
      </ButtonContainer>
    </Modal>
  );
};
